import { useDispatch, useSelector } from 'react-redux';
import { setDoLoginRevert } from '@src/store/slice/authSlice';
import { useEffect } from 'react';
import {DeleteAllCache} from "@src/utils/utils";
import { Helmet } from 'react-helmet';

const Redirect = () => {
  const { adminToken } = useSelector(state => state?.auth);
  const dispatch = useDispatch();

  const doLogin = async () => {
    await dispatch(setDoLoginRevert(adminToken));
    window.location.href = '/admin/dashboard';
  };
  useEffect(() => {
    if (adminToken) {
      (async () => {
        await DeleteAllCache();
        await doLogin();
      })();
    }
  }, []);

  return (
    <>
    <Helmet>
    <meta name="robots" content="noindex"/>
    </Helmet>
    <div className="edenred-loading-global">
      <div className="ant-spin-container">
        <div className="ant-spin-blur">
          <div className="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Redirect;
